module.exports = __webpack_public_path__ + "img/csd-board-mobile.dc1a8242.svg";